declare global {
    interface Window { analytics: any; }
}

export const loadAnalytics = () => {
    window.analytics.load(process.env.VUE_APP_SEGMENT_KEY);
};

export const trackPage = () => {
    window.analytics.page();
};

export const trackAction = (name: string, properties: Record<string, any>) => {
    window.analytics.track(name, properties);
};

export const identifyUser = (userId: string, retailerId: string) => {
    window.analytics.identify(userId, { retailerId });
};
